package org.example.project
import kotlinx.browser.window // 确保引入这个包
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

interface Platform {
    val name: String
}

data class FirebaseConfig( // 初始化firebase需要的数据
    val apiKey: String,
    val authDomain: String,
    val projectId: String,
    val storageBucket: String,
    val messagingSenderId: String,
    val appId: String,
    val measurementId: String
)

val BACKEND_URL: String
    get() {
        // 获取当前网页在浏览器里的域名
        val currentHostname = window.location.hostname
        val stagingUrl = "https://api-staging.plushmorph.com"
        val productionUrl = "https://api.plushmorph.com"
        return when (currentHostname) {
            "localhost", "127.0.0.1" -> {
                stagingUrl // 可能本地也需要测试 productionUrl
            }

            "www.plushmorph.com", "plushmorph.com" -> {
                productionUrl
            }

            else -> {
                stagingUrl
            }
        }
    }

// 获取当前运行平台信息
expect fun getPlatform(): Platform

// 初始化 Firebase SDK
expect fun initializeFirebase(config: FirebaseConfig)

// 谷歌账号登录
expect suspend fun signInWithGoogle(): Boolean

// 苹果账号登录
expect suspend fun signInWithApple(): Boolean

// 邮箱密码登录
expect suspend fun signInWithEmail(email: String, pass: String): String?

// 退出登录
expect suspend fun signOut()

// 监听登录状态变化
expect fun listenToAuthState(onStateChanged: (Boolean) -> Unit)

// 获取当前用户显示名称（从 Firebase SDK 获取）
expect fun getCurrentUserDisplayName(): String?

// 获取当前用户邮箱（从 Firebase SDK 获取）
expect fun getCurrentUserEmail(): String?

// 获取当前用户 UID（从 Firebase SDK 获取）
expect fun getCurrentUserUid(): String?

// 获取当前用户的 ID Token (用于后端 API 鉴权)
expect suspend fun getCurrentUserIdToken(): String?

// 监听 Firestore 用户文档，负责让前端实时读数据
expect fun listenToUserDocument(uid: String, onDocumentUpdate: (UserDocument?) -> Unit): () -> Unit
expect fun listenToSystemProfileDocument(uid: String, onDocumentUpdate: (SystemProfileDocument?) -> Unit): () -> Unit

// 获取浏览器 User-Agent (用于 Claim 接口)
expect fun getUserAgent(): String

